import {
    Edit,
    required,
    TextInput,
    BooleanInput,
    Link,
    FunctionField,
    SimpleForm,
    TabbedShowLayout,
    Tab, useNotify, useDataProvider, useRefresh
} from "react-admin";
import * as React from "react";
import {useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import EventLocalization from "./eventLocalization";
import {Calendar} from "react-multi-date-picker";
import {convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

export const EditEvent = () => {
    const {id} = useParams();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const dispatch = useDispatch();

    const onDateChange = (e, period) => {
        if (e && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            formData[period] = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`;
        }
    }

    const [formData] = useState({
        name: '',
        start_date: '',
        end_date: ''
    });

    const editCreate = () => {
        let startDate = formData.start_date || document.getElementById('start_date').value;
        let endDate = formData.end_date || document.getElementById('end_date').value;

        if(!startDate.length) {
            notify('Start date is required', 'warning');
            return ;
        }

        if(!endDate.length) {
            notify('End date is required', 'warning');
            return ;
        }

        if(startDate.length && endDate.length) {
            let startD = new Date(startDate);
            let endD = new Date(endDate);
            if (startD.getTime() > endD.getTime()) {
                notify("Start date can't be earlier than end date", 'warning');
                return ;
            }
        }

        if (!formData.name.length) {
            document.querySelector('.name').classList.add('error');

            return;
        }

        dispatch(setLoadStatus(true));
        dataProvider.update(`events/general`, {id: `${id}`, data: {
                name: formData.name,
                start_date: startDate,
                end_date: endDate
            }}).then(() => {
            dispatch(setLoadStatus(false));
            refresh(true);
            notify(`Event general update`);
        }).catch((err) => {
            notify(err.message, {type: 'error'});
            dispatch(setLoadStatus(false));
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                    <Link to="/events/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={editCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    return (
        <>
            <h2 className="dailyTitle">Edit Event</h2>
            <Edit title="Edit Event">
                <TabbedShowLayout className="tabbedForm">
                    <Tab label="General">
                        <SimpleForm toolbar={<></>}>
                            <FunctionField label="" render={(record) => {
                                formData.name = record.name;
                                return <>
                                    <TextInput className="formFields name" label="Name" source="name" fullWidth id="name" validate={required()} onChange={(e) => {
                                        nameChange(e)
                                    }} multiline/>
                                    <p className="required-text">Required</p>
                                </>;
                            }}/>
                            <span className="showDateLabel">Start Date</span>
                            <FunctionField source="start_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.start_date ? convertedDateWithTimeGMT(record.start_date, '') : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'start_date')
                                            }}
                                            format="YYYY-MM-DD HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="start_date"
                                               value={record.start_date && !formData.start_date ? convertedDateWithTimeGMT(record.start_date) : formData.start_date}/>
                                    </>
                                );
                            }}/>
                            <span className="showDateLabel showDateLabelEnd">End Date</span>
                            <FunctionField source="end_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.end_date ? convertedDateWithTimeGMT(record.end_date, '') : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'end_date')
                                            }}
                                            format="YYYY-MM-DD HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="end_date"
                                               value={record.end_date && !formData.end_date ? convertedDateWithTimeGMT(record.end_date) : formData.end_date}/>
                                    </>
                                );
                            }}/>
                            <Save />
                        </SimpleForm>
                    </Tab>
                    <Tab label="EN" path="en">
                        <EventLocalization />
                    </Tab>
                    <Tab label="PT" path="pt">
                        <EventLocalization />
                    </Tab>
                    <Tab label="DE" path="de">
                        <EventLocalization />
                    </Tab>
                </TabbedShowLayout>
            </Edit>
        </>
    );
}